<ng-container *ngIf="windowHash; else noModal">
  <!-- cabecera para acciones de tareas en modo modal -->
  <sub-header [isModal]="true" [includeContextHelp]="true" [windowHash]="windowHash"></sub-header>
  <p-scrollPanel [style]="{width: '100%', height: '80vh'}" styleClass="custombar1">
    <ng-container *ngTemplateOutlet="templateBase"></ng-container>
  </p-scrollPanel>
</ng-container>

<ng-template #noModal>
  <div class="wrapper wrapper-content  BASETASKINMODAL">
    <ng-container *ngTemplateOutlet="templateBase"></ng-container>
  </div>
</ng-template>

<ng-template #templateBase>
  <div class="container-fluid p-0 BASETASK">
    <div #parent>
    </div>
  </div>
</ng-template>